import React from 'react';

function Header(){
    return (
        <div>
            <h2 className='bg-warning' style={{padding:'30px'}} >Welcome to Courses Application</h2>
        </div>
    );
}
export default Header;